import { EventEmitter } from "events";

import Dispatcher from "./dispatcher";
import Constants from "./constants";
import getSidebarNavItems from "../data/sidebar-nav-items";
import Login from "../views/Login";

let _store = {
  menuVisible: false,
  navItems: getSidebarNavItems(),
  areas: [],
  apps: [],
  logged_in: false
};

class Store extends EventEmitter {
  constructor() {
    super();

    this.registerToActions = this.registerToActions.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.setAreas = this.setAreas.bind(this);
    this.setApps = this.setApps.bind(this);
    this.setLoggedIn = this.setLoggedIn.bind(this);

    this.retrieveApps = this.retrieveApps.bind(this);
    this.loginUser = this.loginUser.bind(this);


    Dispatcher.register(this.registerToActions.bind(this));
  }

  registerToActions({ actionType, payload }) {
    switch (actionType) {
      case Constants.TOGGLE_SIDEBAR:
        this.toggleSidebar();
        break;
        case Constants.SET_AREAS:
            this.setAreas(payload);
        break;

        case Constants.SET_APPS:
            this.setApps(payload);
        break;
      default:
    }
  }

  setAreas(Areas) {

    _store.areas = Areas;
  }

  setApps(Apps) {

    _store.apps = Apps;
  }

  getApps() {

    return _store.apps;
  }

  getLoggedIn() {

    return _store.logged_in;
  }

  setLoggedIn(LoggedIn) {

    _store.logged_in = LoggedIn;
  }

  async loginUser(Username, Password) {

    const LoginDetails = JSON.stringify({ user: Username, pass: Password });

    const Response = await fetch("https://app-centre.tascomi.com/app-centre.php?end_point=login_user&data=" + LoginDetails);
    const Data = await Response.json();

    this.setLoggedIn(Data);
    localStorage.setItem("TMOB_LOGGEDIN", Data);

    if (Data) {

        localStorage.setItem("TMOB_LOGIN", window.btoa(LoginDetails));
    }

    return Data;
    // this.setAreas(Data);
  }

  async retrieveAreas() {

    const Response = await fetch("https://app-centre.tascomi.com/app-centre.php?end_point=get_areas_overview");
    const Data = await Response.json();
    this.setAreas(Data);
  }

  async retrieveApps() {

    const Response = await fetch("https://app-centre.tascomi.com/app-centre.php?end_point=get_apps_overview");
    const Data = await Response.json();
    this.setApps(Data);
  }

  getAreas() {

    return _store.areas;
  }

  toggleSidebar() {
    _store.menuVisible = !_store.menuVisible;
    this.emit(Constants.CHANGE);
  }

  getMenuState() {
    return _store.menuVisible;
  }

  getSidebarItems() {
    return _store.navItems;
  }

  addChangeListener(callback) {
    this.on(Constants.CHANGE, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
  }
}

export default new Store();
